module.exports = __webpack_public_path__ + "static/media/todo_blue.38401955.png";